import React, { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { RecoilRoot, useRecoilValue } from 'recoil';

import { FloatingTree } from '@floating-ui/react';

//import '@ecp/common/src/assets/css/default.css';
import GlobalStyle from '@ecp/common/src/style/GlobalStyle';
import useViewportHeight from '@ecp/common/src/hooks/useViewportHeight';

import useWhatapRumMO from '@ecp/common/src/hooks/useWhatapRumMO';

import RecoilExternalStatePortal from '@mo-recoil/RecoilExternalStatePortal';
import useSiteInfo from '@mo-hooks/common/useSiteInfo';
import ToastProvider from '@mo-components/common/provider/ToastProvider';
import LoadingSpinner from '@mo-components/common/LoadingSpinner';
import SiteInformationProvider from '@mo-components/common/provider/SiteInformationProvider';
import SuspenseSpinner from '@mo-components/common/SuspenseSpinner';
import InvisibleLoading from '@mo-components/common/InvisibleLoading';
import routes from '@ecp/mo/src/routes/Routes';
import './App.css';

import useNetfunnelComplete from '@ecp/common/src/hooks/useNetfunnelComplete';
import { ThemeProvider } from 'styled-components';
import { themeState } from './recoil/theme/atom';

function ThemedApp() {
  const { isPending } = useSiteInfo();
  const theme = useRecoilValue(themeState);

  return isPending ? null : (
    <ThemeProvider theme={theme}>
      <SiteInformationProvider />
      <GlobalStyle />
      <FloatingTree>
        <InvisibleLoading />
        <LoadingSpinner />
        <Suspense fallback={<SuspenseSpinner height={'100vh'} message={'페이지를 열고 있어요\n조금만 기다려주세요'} />}>
          <RouterProvider router={routes}></RouterProvider>
        </Suspense>
        <ToastProvider />
      </FloatingTree>
      <RecoilExternalStatePortal />
    </ThemeProvider>
  );
}

export default function App() {
  useViewportHeight();
  useNetfunnelComplete();
  useWhatapRumMO();

  return (
    <RecoilRoot>
      <ThemedApp />
    </RecoilRoot>
  );
}
